<template>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 95.71 35.97">
        <g id="Layer_2" data-name="Layer 2">
            <g id="Layer_4" data-name="Layer 4">
                <path
                    d="M86.75,0H9A9,9,0,0,0,0,9V27a9,9,0,0,0,9,9H86.75a9,9,0,0,0,9-9V9A9,9,0,0,0,86.75,0ZM36.21,29.48H23.61l-3-5.24-3.36,5.24H4.63l7.83-10.85L4.29,7.07H17.77l2.82,6,3-6H36.72L28.49,18.63Zm23.46,0H38.33V7.07H49.86V21.55h9.81ZM84.47,28c-2.35,1.47-4.84,1.95-10,1.95a61.14,61.14,0,0,1-12.43-1.15V22.66a76.45,76.45,0,0,0,12.53,1.08c1,0,1.55-.34,1.55-1S75.77,22,74.56,22H72.68c-.91,0-2.93-.14-4.24-.27-2.82-.3-4.53-1.08-5.68-2.56a6.82,6.82,0,0,1-1.31-4.3,7,7,0,0,1,2.66-5.91c2-1.48,6-2.32,11.16-2.32A62.56,62.56,0,0,1,87.09,7.71V14.3a83.49,83.49,0,0,0-9-.78H75.54c-1.55,0-2.16.31-2.16,1s.48.91,1.25.91l4,0a18.78,18.78,0,0,1,5.78.84A5.84,5.84,0,0,1,88,21.89,7.27,7.27,0,0,1,84.47,28Z"
                    fill="#fff"
                />
            </g>
        </g>
    </svg>
</template>
<script>
export default {};
</script>



// WEBPACK FOOTER //
// ExportXlsIcon.vue?3dffb98f